/*
 *
 * Do not edit directly
 * Generated on Wed, 16 Jul 2025 15:14:59 GMT
 *
 */


const theme = {
  appearances: {},
  rules: [],
  tokens: {
    buttonBackgroundColor: null,
    buttonBorderColor: null,
    buttonBorderRadius: null,
    buttonBorderWidth: null,
    buttonHeight: null,
    buttonMinWidth: null,
    buttonTextColor: null,
    buttonWidth: null,
    notificationBackgroundColor: null,
    notificationBorderColor: null,
    notificationBorderRadius: null,
    notificationDismissButtonGap: null,
    notificationDismissIcon: null,
    notificationDismissIconColor: null,
    notificationIcon: null,
    notificationIconColor: null,
    notificationIconGap: null,
    notificationIconSize: null,
    notificationTextColor: '#000000'
  }
}
export default theme
